module.exports = __webpack_public_path__ + "img/m-hd.5875a2aa.jpg";